import getUrl from "@/Helpers/BaseUrl";
import axios from "axios";
export async function getEmployees(page, pageSize) {
    const response = await axios.get(getUrl(`/eci/v1/crmweb/Employee?page=${page}&size=${pageSize}`));
    return response.data;
}
